import { useState } from "react";

import { useRootStore } from "store";
import { Icon } from "components/icon/Icon";
import { updateFavoriteCustomerList } from "common/customer/getFavoriteCustomer";
import MenuDropdown from "components/menu/MenuDropdown/MenuDropdown";

import "./MenuDropdown.scss";

type Props = {
  handleChangeCustomer: (customerId: string) => void;
};

export default function ExternalUserCustomerMenu({
  handleChangeCustomer
}: Props) {
  const { userInfo } = useRootStore((state) => state.user);
  const { workingCustomerId, favoriteCustomer } = useRootStore(
    (state) => state.global
  );
  const { unfilteredCustomers: customers } = useRootStore(
    (state) => state.customers.myCustomers
  );
  const [search, setSearch] = useState("");

  const customersItems = customers
    .filter(
      (c) =>
        search === "" ||
        c.customerName.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => (a.customerName > b.customerName ? 1 : -1));

  const setFavoriteCustomer = (
    e: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    customerNumber: string
  ) => {
    e.stopPropagation();
    const chosenCustomer = {
      userId: userInfo ? userInfo.id : "",
      customerId: customerNumber
    };
    updateFavoriteCustomerList(chosenCustomer);
  };

  const searchMenuItem = {
    content: (
      <div className="customerSearchWrapper">
        <input
          placeholder="Sök verksamhet..."
          type="text"
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    ),
    hasDivider: true,
    className: "p-0"
  };

  const customersMenuItems = customersItems.map((customer) => ({
    content: (
      <div className="d-flex justify-content-between">
        <span
          className={
            workingCustomerId === customer.customerNumber ? "fw-bold" : ""
          }
        >
          {customer.customerName}
        </span>
        <span
          className={
            favoriteCustomer?.customerId === customer.customerNumber
              ? "favoriteActive"
              : "favorite"
          }
          title={
            favoriteCustomer?.customerId === customer.customerNumber
              ? `Ta bort som favorit`
              : `Lägg till som favorit`
          }
          onClick={(e) => setFavoriteCustomer(e, customer.customerNumber)}
        >
          <Icon
            name={
              favoriteCustomer?.customerId === customer.customerNumber
                ? "star"
                : "star-o"
            }
          />
        </span>
      </div>
    ),
    onClick: () => handleChangeCustomer(customer.customerId)
  }));

  const hasMultipleOperations = customers.length >= 5;

  const allMenuItems = [
    ...(hasMultipleOperations ? [searchMenuItem] : []),
    ...customersMenuItems,
    ...(search !== "" && customersItems.length === 0
      ? [
          {
            content: <p>Inga sökresultat på "{search}".</p>
          }
        ]
      : [])
  ];

  return (
    <>
      <div className="customerDropdown">
        <MenuDropdown toggleText="Mina verksamheter" menuItems={allMenuItems} />
      </div>

      <div className="customerMenuFullscreen">
        <h2>Mina verksamheter </h2>
        {hasMultipleOperations && (
          <div className="customerSearchWrapper">
            <input
              placeholder="Sök verksamhet..."
              type="text"
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        )}
        <ul>
          {customersMenuItems.map((customerItem, i) => (
            <li key={i}>
              <a onClick={customerItem.onClick}>{customerItem.content}</a>
            </li>
          ))}

          {search !== "" && customersItems.length === 0 && (
            <p>Inga sökresultat på "{search}".</p>
          )}
        </ul>
      </div>
    </>
  );
}
